/**
 * Admin allowlist — by verified email.
 *
 * Kept in sync between three places (manual sync; rules can't import):
 *   - this file (client AdminGuard + admin UI)
 *   - firestore.rules (isAdmin() helper)
 *   - storage.rules (isAdmin() helper)
 *
 * To add an admin: append the email here AND update both rules files,
 * then deploy: `firebase deploy --only firestore:rules,storage`.
 *
 * email_verified is required — protects against an attacker claiming
 * one of these addresses via email/password signup before the real
 * owner does. Google sign-in auto-verifies; password-auth users must
 * click the verification email link before admin access kicks in.
 */
export const ADMIN_EMAILS: readonly string[] = [
  'kckernen@gmail.com',       // Kevin (Google)
  'kevin@kevinkernen.com',    // Kevin (alternate)
  'satwell@erinind.com',      // Steve (business email)
  'steatwe@gmail.com',        // Steve (Google)
];
